import React, { useState } from 'react';
import '../components/css/faq.css'; // 

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What is sustainable agriculture?",
      answer: "Sustainable agriculture focuses on producing food in ways that preserve the environment, support rural communities, and optimize resource use. Our platform helps farmers implement sustainable practices through data-driven recommendations and monitoring tools."
    },
    {
      question: "How does your platform help improve crop yields?",
      answer: "Our platform analyzes soil conditions, weather patterns, and historical farm data to provide personalized recommendations for planting, irrigation, and fertilization. Users typically see a 15-30% increase in yields after implementing our suggestions."
    },

    {
      question: "What data security measures do you implement?",
      answer: "We take farm data security seriously. All data is encrypted both in transit and at rest, stored in secure cloud environments with regular backups. We never share your farm data with third parties without explicit permission."
    },
    {
      question: "Is training available for new users?",
      answer: "Absolutely! We offer free onboarding sessions for all new users. Additional training modules and webinars are available through our Learning Center. Our support team is also available 24/7 to answer any questions."
    },
    {
      question: "Can I use the platform on mobile devices?",
      answer: "Yes, our platform is fully responsive and works on smartphones and tablets. We also offer dedicated mobile apps for both iOS and Android with offline functionality for field use."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h2 className="faq-title">
        Frequently Asked 
        <br/>
        Questions
        </h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div 
            key={index} 
            className="faq-item"
          >
            <button
              className="faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span>{faq.question}</span>
              <span className="faq-icon">
                {activeIndex === index ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                )}
              </span>
            </button>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;